import { useState, useEffect } from 'react'
import PlayerService from 'src/service/PlayerService'

const useChartData = () => {
  const [scData, setScData] = useState([])
  const [hwData, setHwData] = useState([])
  const [awData, setAwData] = useState([])
  const [alData, setAlData] = useState([])
  const [hlData, setHlData] = useState([])
  const [sswData, setSswData] = useState([])
  const [sslsData, setSslsData] = useState([])
  const [owtData, setOwtData] = useState([])
  const [bwmData, setBwmData] = useState([])
  const [blmData, setBlmData] = useState([])

  const [fpsData, setFpsData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    PlayerService.getPlayerPieChartValue().then((res) => {
      setLoading(true)
      if (res.status === 200) {
        setScData(res.scRangeData)
        setHwData(res.hwRangeData)
        setAwData(res.awRangeData)
        setAlData(res.alRangeData)
        setHlData(res.hlRangeData)
        setSswData(res.sswRangeData)
        setSslsData(res.sslsRangeData)
        setOwtData(res.owtRangeData)
        setBwmData(res.bwmRangeData)
        setBlmData(res.blmRangeData)
        setFpsData(res.fpRangeData)
        setLoading(false)
      }
    })
  }, [])

  const dataScValues = Object.values(scData).map((value) => parseInt(value, 10))
  const dataHwValues = Object.values(hwData).map((value) => parseInt(value, 10))
  const dataAwValues = Object.values(awData).map((value) => parseInt(value, 10))
  const dataAlValues = Object.values(alData).map((value) => parseInt(value, 10))
  const dataHlValues = Object.values(hlData).map((value) => parseInt(value, 10))
  const dataSswValues = Object.values(sswData).map((value) => parseInt(value, 10))
  const dataSslsValues = Object.values(sslsData).map((value) => parseInt(value, 10))
  const dataOwtValues = Object.values(owtData).map((value) => parseInt(value, 10))
  const dataBwmValues = Object.values(bwmData).map((value) => parseInt(value, 10))
  const dataBlmValues = Object.values(blmData).map((value) => parseInt(value, 10))
  const dataFpValues = Object.values(fpsData).map((value) => parseInt(value, 10))

  const formattedScData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Score Per match',
        backgroundColor: '#36A2EB',
        data: dataScValues,
      },
    ],
  }

  const formattedHwData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Home Win Per Match',
        backgroundColor: '#4BC0C0',
        data: dataHwValues,
      },
    ],
  }

  const formattedAwsData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Away Win Per Match',
        backgroundColor: '#36A2EB',
        data: dataAwValues,
      },
    ],
  }

  const formattedAlData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Away Loss Per Match',
        backgroundColor: '#4BC0C0',
        data: dataAlValues,
      },
    ],
  }

  const formattedFpData = {
    labels: ['1-5', '6-10', '11-15', '16-20', '21-30', '31-40', '41-50', '51+'],
    datasets: [
      {
        label: 'Fantasy Points Per Inning',
        backgroundColor: '#36A2EB',
        data: dataFpValues,
      },
    ],
  }

  const formattedHlData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Home Loss Per Match',
        backgroundColor: '#4BC0C0',
        data: dataHlValues,
      },
    ],
  }
  const formattedSswData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Single Score Win Per Match',
        backgroundColor: '#4BC0C0',
        data: dataSswValues,
      },
    ],
  }
  const formattedSslsData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Single Score Loss Per Match',
        backgroundColor: '#4BC0C0',
        data: dataSslsValues,
      },
    ],
  }
  const formattedOwtData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Only Winner in Team Per Match',
        backgroundColor: '#4BC0C0',
        data: dataOwtValues,
      },
    ],
  }
  const formattedBwmData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Biggest Win Margin Per Match',
        backgroundColor: '#4BC0C0',
        data: dataBwmValues,
      },
    ],
  }
  const formattedBlmData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Biggest Loss Margin Per Match',
        backgroundColor: '#4BC0C0',
        data: dataBlmValues,
      },
    ],
  }

  return {
    loading,
    formattedScData,
    formattedHwData,
    formattedAwsData,
    formattedAlData,
    formattedHlData,
    formattedSswData,
    formattedSslsData,
    formattedOwtData,
    formattedBwmData,
    formattedBlmData,
    formattedFpData,
  }
}

export default useChartData
